import { render, staticRenderFns } from "./RsaScalaIdaViewComponent.vue?vue&type=template&id=50ccf46c"
import script from "./RsaScalaIdaViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaScalaIdaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports